import { Component, OnInit, ViewChild } from "@angular/core";
import { TouchcrApiAffiliateComponent } from "../src/services/touchcr-api-affiliate/touchcr-api-affiliate.component";
import { UrlsProvider } from 'src/app/providers/urls';
import { SpinnerProvider } from 'src/app/providers/spinner/spinner';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { StateExtenderProvider } from 'src/app/providers/state-extender';
import { FunnelSettingsExtenderProvider } from "src/app/providers/funnel-settings-extender";
import { GundrySecureCartComponent } from "../gundry-secure-cart/gundry-secure-cart.component";
import { BRAND_LOGO_GREEN } from "../../constants/constants-brand";
import { Router } from "@angular/router";

@Component({
  selector: "app-gdpr",
  templateUrl: "./gdpr.component.html",
  styleUrls: ["./gdpr.component.scss"],
})
export class GdprComponent extends GundrySecureCartComponent {
  brandLogo = BRAND_LOGO_GREEN;
  footerLinks: Array<any> = [];
  public genericUrlToOpenNewTab: string = '';
  public innerWidth: number;
  public innerHeight: number;

  @ViewChild('dialog') dialog: any;

  constructor(
    public override urls: UrlsProvider,
    public override spinner: SpinnerProvider,
    public override navCtrl: NavControllerExt,
    public override stateProvider: StateExtenderProvider,
    public override tcrApiAffiliate: TouchcrApiAffiliateComponent,
    public override funnelProvider: FunnelSettingsExtenderProvider,
    public override router: Router

  ) {
    super( urls, tcrApiAffiliate, funnelProvider, spinner, navCtrl, stateProvider, router );
 
    this.populatePageData();
    this.footerLinks = [];
  }

  async populatePageData() {
    this.noticeOn = false;
    this.noticeText = `<p><span class="bold">UPDATE:</span> Due to extreme weather conditions, some customers may experience shipping delays.<p>`;
    this.showOnOrderForm = true;
    this.brandFooterObj = { link: "http://drmartypets.com", label: "Dr. Marty Pets" };
  }

     // Use for navigation to specific page by its Generic Url
     public navigateToPageByGenericUrl(url: string): void {

      if(url.startsWith("http")) {
        window.open(url, '_top', `width=${this.innerWidth},height=${this.innerHeight}`);
      } else {
        const currentSessionId = this.funnelProvider.getSessionId();
        const pathName = url;
        let newQueryParams = this.urls.addParamToQuery(
          `${this.getSearch()}`,
          'sessionid',
          currentSessionId
        );
        const nextUrl = `${window.location.origin}/${
          pathName
        }${newQueryParams}`;
        window.open(nextUrl, '_top', `width=${this.innerWidth},height=${this.innerHeight}`); 
      }
    }
}
